// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/presentation-chart-line.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'presentation-chart-line',
  version: 'outline',
  paths: [
    {
      d: 'M3.75 3v11.25A2.25 2.25 0 0 0 6 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0 1 18 16.5h-2.25m-7.5 0h7.5m-7.5 0-1 3m8.5-3 1 3m0 0 .5 1.5m-.5-1.5h-9.5m0 0-.5 1.5m.75-9 3-3 2.148 2.148A12.061 12.061 0 0 1 16.5 7.605',
    },
  ],
}
